import {
  API_ENDPOINT,
  useClientApiV1MockInterviewsFreeCreateMutation,
} from '../../resources/@types/studyAgentSchema';

interface UseClientV1MockInterviewsFreeCreateMutation {
  options?: Parameters<typeof useClientApiV1MockInterviewsFreeCreateMutation>[0]['options'];
}

export function useMockInterviewCreateFreeMutation({
  options,
}: UseClientV1MockInterviewsFreeCreateMutation) {
  return useClientApiV1MockInterviewsFreeCreateMutation({
    url: API_ENDPOINT.CLIENT_V1_MOCK_INTERVIEWS_FREE,
    options,
  });
}
